/*
 *
 * OperationCurrency
 *
 * @version 1.0.0
 * @author Andrea Esposito
 * @since 26-May-2026
 */

import { connect } from 'react-redux'
import OperationCurrency from './OperationCurrency'

const mapDispatchToProps = {}

const mapStateToProps = (state) => ({
  isLoading: state?.loading?.local_OperationDetails || false
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(OperationCurrency)
